import React from "react"
import strings from "../../../localization/strings"
import { TextField, Toggle } from "material-ui"
import autobind from "class-autobind"
import AccountStore from "../../../stores/AccountStore"
import * as accountActions from "../../../actions/AccountActions"
interface IProps {
	enableSchedule: boolean
}
interface IState {
	minutesToTriggerMissingPunchInException: number
	minutesToTriggerLatePunchInException: number
	minutesToTriggerEarlyPunchInException: number
	minutesToTriggerEarlyPunchOutException: number
	minutesToTriggerLatePunchOutException: number
	enableMissingBreakException: boolean
	minutesToTriggerLongBreakException: number
	enableNoShiftException: boolean
	daysToTriggerMissingEmployeeApproval: number
	daysToTriggerMissingSupervisorApproval: number
	errorMinutesToTriggerMissingPunchInException?: string
	errorMinutesToTriggerLatePunchInException?: string
	errorMinutesToTriggerEarlyPunchInException?: string
	errorMinutesToTriggerEarlyPunchOutException?: string
	errorMinutesToTriggerLatePunchOutException?: string
	errorMinutesToTriggerLongBreakException?: string
	errorDaysToTriggerMissingEmployeeApproval?: string
	errorDaysToTriggerMissingSupervisorApproval?: string
	hoursToTriggerDeviceConnectException: number
	errorHoursToTriggerDeviceConnectException?: string
}
const styles = {
	errorTextStyle: {
		position: "absolute",
		bottom: -10
	},
	textStyle: {
		marginBottom: 10,
		width: 350
	},
	toggleStyle: {
		width: 250,
		marginTop: 15,
		marginBottom: 15,
	}
}

export default class ExceptionSettings extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props)
		this.state = {
			minutesToTriggerMissingPunchInException: AccountStore.getCurrentAccountSettings().ScheduleSettings.MinutesToTriggerMissingPunchInException,
			minutesToTriggerLatePunchInException: AccountStore.getCurrentAccountSettings().ScheduleSettings.MinutesToTriggerLatePunchInException,
			minutesToTriggerEarlyPunchInException: AccountStore.getCurrentAccountSettings().ScheduleSettings.MinutesToTriggerEarlyPunchInException,
			minutesToTriggerEarlyPunchOutException: AccountStore.getCurrentAccountSettings().ScheduleSettings.MinutesToTriggerEarlyPunchOutException,
			minutesToTriggerLatePunchOutException: AccountStore.getCurrentAccountSettings().ScheduleSettings.MinutesToTriggerLatePunchOutException,
			enableMissingBreakException: AccountStore.getCurrentAccountSettings().ScheduleSettings.EnableMissingBreakException,
			minutesToTriggerLongBreakException: AccountStore.getCurrentAccountSettings().ScheduleSettings.MinutesToTriggerLongBreakException,
			daysToTriggerMissingEmployeeApproval: AccountStore.getCurrentAccountSettings().ScheduleSettings.DaysToTriggerMissingEmployeeApproval,
			enableNoShiftException: AccountStore.getCurrentAccountSettings().ScheduleSettings.EnableNoShiftException,
			daysToTriggerMissingSupervisorApproval: AccountStore.getCurrentAccountSettings().ScheduleSettings.DaysToTriggerMissingSupervisorApproval,
			hoursToTriggerDeviceConnectException: AccountStore.getCurrentAccountSettings().ScheduleSettings.HoursToTriggerDeviceConnectException,
		}
		autobind(this)
	}

	checkValidate() {
		let isValidate = true
		return isValidate
	}

	handleSave() {
		if (!this.checkValidate()) return
		accountActions.patchAccount(
			AccountStore.getCurrentAccount().Id,
			{
				AccountSettings: {
					ScheduleSettings: {
						MinutesToTriggerMissingPunchInException: this.state.minutesToTriggerMissingPunchInException,
						MinutesToTriggerLatePunchInException: this.state.minutesToTriggerLatePunchInException,
						MinutesToTriggerEarlyPunchInException: this.state.minutesToTriggerEarlyPunchInException,
						MinutesToTriggerEarlyPunchOutException: this.state.minutesToTriggerEarlyPunchOutException,
						MinutesToTriggerLatePunchOutException: this.state.minutesToTriggerLatePunchOutException,
						EnableMissingBreakException: this.state.enableMissingBreakException,
						MinutesToTriggerLongBreakException: this.state.minutesToTriggerLongBreakException,
						DaysToTriggerMissingEmployeeApproval: this.state.daysToTriggerMissingEmployeeApproval,
						DaysToTriggerMissingSupervisorApproval: this.state.daysToTriggerMissingSupervisorApproval,
						EnableNoShiftException: this.state.enableNoShiftException,
						HoursToTriggerDeviceConnectException: this.state.hoursToTriggerDeviceConnectException
					}
				}
			}
		)
	}

	render() {
		return (
			<div>
				{this.props.enableSchedule &&
					<div>
						<TextField
							data-intercom-target={"menu-AccountSettings-ExceptionSettings-Entry-MinToTriggerMissingPunchInException"}
							floatingLabelText={strings.Minutes_To_Trigger_Missing_PunchIn_Exception}
							value={this.state.minutesToTriggerMissingPunchInException}
							onChange={(e, value) => this.setState({ minutesToTriggerMissingPunchInException: value }, () => this.handleSave())}
							errorText={this.state.errorMinutesToTriggerMissingPunchInException}
							errorStyle={styles.errorTextStyle}
							style={styles.textStyle}
							type="number"
						/>
						{strings.minutes}
						<br />
						<TextField
							data-intercom-target={"menu-AccountSettings-ExceptionSettings-Entry-MinToTriggerEarlyPunchInException"}
							floatingLabelText={strings.Minutes_To_Trigger_Early_PunchIn_Exception}
							value={this.state.minutesToTriggerEarlyPunchInException}
							onChange={(e, value) => this.setState({ minutesToTriggerEarlyPunchInException: value }, () => this.handleSave())}
							errorText={this.state.errorMinutesToTriggerEarlyPunchInException}
							errorStyle={styles.errorTextStyle}
							style={styles.textStyle}
							type="number"
						/>
						{strings.minutes}
						<br />
						<TextField
							data-intercom-target={"menu-AccountSettings-ExceptionSettings-Entry-MinToTriggerLatePunchInException"}
							floatingLabelText={strings.Minutes_To_Trigger_Late_PunchIn_Exception}
							value={this.state.minutesToTriggerLatePunchInException}
							onChange={(e, value) => this.setState({ minutesToTriggerLatePunchInException: value }, () => this.handleSave())}
							errorText={this.state.errorMinutesToTriggerLatePunchInException}
							errorStyle={styles.errorTextStyle}
							style={styles.textStyle}
							type="number"
						/>
						{strings.minutes}
						<br />
						<TextField
							data-intercom-target={"menu-AccountSettings-ExceptionSettings-Entry-MinToTriggerEarlyPunchOutException"}
							floatingLabelText={strings.Minutes_To_Trigger_Early_PunchOut_Exception}
							value={this.state.minutesToTriggerEarlyPunchOutException}
							onChange={(e, value) => this.setState({ minutesToTriggerEarlyPunchOutException: value }, () => this.handleSave())}
							errorText={this.state.errorMinutesToTriggerEarlyPunchOutException}
							errorStyle={styles.errorTextStyle}
							style={styles.textStyle}
							type="number"
						/>
						{strings.minutes}
						<br />
						<TextField
							data-intercom-target={"menu-AccountSettings-ExceptionSettings-Entry-MinToTriggerLatePunchOutException"}
							floatingLabelText={strings.Minutes_To_Trigger_Late_PunchOut_Exception}
							value={this.state.minutesToTriggerLatePunchOutException}
							onChange={(e, value) => this.setState({ minutesToTriggerLatePunchOutException: value }, () => this.handleSave())}
							errorText={this.state.errorMinutesToTriggerLatePunchOutException}
							errorStyle={styles.errorTextStyle}
							style={styles.textStyle}
							type="number"
						/>
						{strings.minutes}
						<br />
						<TextField
							data-intercom-target={"menu-AccountSettings-ExceptionSettings-Entry-MinToTriggerLongBreakException"}
							floatingLabelText={strings.Minutes_To_Trigger_Long_Break_Exception}
							value={this.state.minutesToTriggerLongBreakException}
							onChange={(e, value) => this.setState({ minutesToTriggerLongBreakException: value }, () => this.handleSave())}
							errorText={this.state.errorMinutesToTriggerLongBreakException}
							errorStyle={styles.errorTextStyle}
							style={styles.textStyle}
							type="number"
						/>
						{strings.minutes}
						<br />
					</div>
				}
				{AccountStore.getCurrentAccountSettings().FeatureSettings.EnableEmployeeApproveTimecard &&
					<div>
						<TextField
							data-intercom-target={"menu-AccountSettings-ExceptionSettings-Entry-DaysToTriggerMissingEmployeeApproval"}
							floatingLabelText={strings.Days_To_Trigger_Missing_Employee_Approval}
							value={this.state.daysToTriggerMissingEmployeeApproval}
							onChange={(e, value) => this.setState({ daysToTriggerMissingEmployeeApproval: value }, () => this.handleSave())}
							errorText={this.state.errorDaysToTriggerMissingEmployeeApproval}
							errorStyle={styles.errorTextStyle}
							style={styles.textStyle}
							type="number"
						/>
						{strings.Days.toLowerCase()}
						<br />
					</div>
				}
				<TextField
					data-intercom-target={"menu-AccountSettings-ExceptionSettings-Entry-DaysToTriggerMissingSupervisorApproval"}
					floatingLabelText={strings.Days_To_Trigger_Missing_Supervisor_Approval}
					value={this.state.daysToTriggerMissingSupervisorApproval}
					onChange={(e, value) => this.setState({ daysToTriggerMissingSupervisorApproval: value }, () => this.handleSave())}
					errorText={this.state.errorDaysToTriggerMissingSupervisorApproval}
					errorStyle={styles.errorTextStyle}
					style={styles.textStyle}
					type="number"
				/>
				{strings.Days.toLowerCase()}
				<br />
				<TextField
					data-intercom-target={"menu-AccountSettings-ExceptionSettings-Entry-HoursToTriggerDeviceConnectionException"}
					floatingLabelText={strings.Hours_To_Trigger_Device_Connection_Exception}
					value={this.state.hoursToTriggerDeviceConnectException}
					onChange={(e, value) => this.setState({ hoursToTriggerDeviceConnectException: value }, () => this.handleSave())}
					errorText={this.state.errorHoursToTriggerDeviceConnectException}
					errorStyle={styles.errorTextStyle}
					style={styles.textStyle}
					type="number"
				/>
				{strings.Hours.toLowerCase()}
				<br />
				{this.props.enableSchedule &&
					<div>
						<Toggle
							data-intercom-target={"menu-AccountSettings-ExceptionSettings-Toggle-EnableMissingBreakException"}
							toggled={this.state.enableMissingBreakException}
							onToggle={(e, value) => this.setState({ enableMissingBreakException: value }, () => this.handleSave())}
							labelPosition="left"
							label={strings.Enable_Missing_Break_Exception}
							style={styles.toggleStyle}
						/>
						<Toggle
							data-intercom-target={"menu-AccountSettings-ExceptionSettings-Toggle-EnableNoShiftException"}
							toggled={this.state.enableNoShiftException}
							onToggle={(e, value) => this.setState({ enableNoShiftException: value }, () => this.handleSave())}
							labelPosition="left"
							label={strings.Enable_No_Shift_Exception}
							style={styles.toggleStyle}
						/>
					</div>
				}
			</div>
		)
	}
}